import { render, staticRenderFns } from "./churuKc.vue?vue&type=template&id=55fcceda&scoped=true"
import script from "./churuKc.vue?vue&type=script&lang=js"
export * from "./churuKc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fcceda",
  null
  
)

export default component.exports